module.exports = __webpack_public_path__ + "img/doctor.094597b4.png";